<template>
  <div>
    <el-alert
      title="同仓扣来源、加目标，可换产品、批次或托盘。过账写入库存流水。已过账不能修改或删除。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.repackingCode" clearable placeholder="单号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.repackingState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="已过账" value="01" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新建</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="repackingCode" label="单号" width="180" />
      <el-table-column prop="wareHouseName" label="仓库" width="140" />
      <el-table-column prop="repackingDate" label="日期" width="120" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.repackingState === '01' ? 'success' : 'info'">{{ row.repackingState === '01' ? '已过账' : '草稿' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="postDate" label="过账时间" width="170" />
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column label="操作" width="220" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.repackingId, true)">查看</el-button>
          <el-button v-if="row.repackingState === '00'" type="text" @click="openEdit(row.repackingId)">修改</el-button>
          <el-button v-if="row.repackingState === '00'" type="text" @click="doPost(row)">过账</el-button>
          <el-button v-if="row.repackingState === '00'" type="text" style="color:#ef4444" @click="onDelete(row.repackingId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="readonly ? '查看重包装' : (form.repackingId ? '修改重包装' : '新建重包装')" :visible.sync="visible" width="1100px" :close-on-click-modal="false">
      <el-form :model="form" label-width="80px" :disabled="readonly">
        <el-row :gutter="12">
          <el-col :span="8"><el-form-item label="单号"><el-input v-model="form.repackingCode" placeholder="留空自动生成" /></el-form-item></el-col>
          <el-col :span="8">
            <el-form-item label="仓库" required>
              <el-select v-model="form.wareHouseId" filterable style="width:100%" @change="loadPallets">
                <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="日期">
              <el-date-picker v-model="form.repackingDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item></el-col>
        </el-row>
        <el-button v-if="!readonly" type="primary" size="mini" @click="addLine">添加行</el-button>
        <el-table :data="form.lineList" border size="small" style="margin-top:8px">
          <el-table-column label="来源产品" min-width="180">
            <template slot-scope="{ row }">
              <el-select v-model="row.fromProductId" filterable size="mini" style="width:100%" @change="copyTo(row)">
                <el-option v-for="p in products" :key="p.productId" :label="p.productNumber + ' / ' + (p.productName || '')" :value="p.productId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="来源数量" width="120">
            <template slot-scope="{ row }"><el-input-number v-model="row.fromQty" :min="0" :precision="6" size="mini" style="width:100%" /></template>
          </el-table-column>
          <el-table-column label="来源批号" width="120">
            <template slot-scope="{ row }"><el-input v-model="row.fromBatchNo" size="mini" /></template>
          </el-table-column>
          <el-table-column label="来源托盘" width="130">
            <template slot-scope="{ row }">
              <el-select v-model="row.fromPalletId" clearable filterable size="mini" style="width:100%">
                <el-option v-for="p in pallets" :key="p.palletId" :label="p.palletCode" :value="p.palletId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="目标产品" min-width="180">
            <template slot-scope="{ row }">
              <el-select v-model="row.toProductId" filterable size="mini" style="width:100%">
                <el-option v-for="p in products" :key="'t'+p.productId" :label="p.productNumber + ' / ' + (p.productName || '')" :value="p.productId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="目标数量" width="120">
            <template slot-scope="{ row }"><el-input-number v-model="row.toQty" :min="0" :precision="6" size="mini" style="width:100%" /></template>
          </el-table-column>
          <el-table-column label="目标批号" width="120">
            <template slot-scope="{ row }"><el-input v-model="row.toBatchNo" size="mini" /></template>
          </el-table-column>
          <el-table-column label="目标托盘" width="130">
            <template slot-scope="{ row }">
              <el-select v-model="row.toPalletId" clearable filterable size="mini" style="width:100%">
                <el-option v-for="p in pallets" :key="'tp'+p.palletId" :label="p.palletCode" :value="p.palletId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column v-if="!readonly" label="操作" width="70" align="center">
            <template slot-scope="{ $index }"><el-button type="text" size="mini" @click="form.lineList.splice($index, 1)">删除</el-button></template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">关闭</el-button>
        <el-button v-if="!readonly" type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listRepacking, getRepacking, saveRepacking, updateRepacking, deleteRepacking, postRepacking } from '../../api/repacking'
import { selectEnabledWareHouse } from '../../api/warehouse'
import { selectProduct } from '../../api/product'
import { selectPallet } from '../../api/pallet'

function emptyLine() {
  return {
    fromProductId: '', fromQty: 1, fromBatchNo: '', fromPalletId: '',
    toProductId: '', toQty: 1, toBatchNo: '', toPalletId: ''
  }
}

function emptyForm() {
  return { repackingId: '', repackingCode: '', wareHouseId: '', repackingDate: null, remark: '', lineList: [emptyLine()] }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { repackingCode: '', repackingState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, readonly: false, saving: false, form: emptyForm(),
      warehouses: [], products: [], pallets: []
    }
  },
  created() {
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
    selectProduct().then(res => { this.products = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      listRepacking({ ...this.query, currentPage: this.page, pageSize: this.pageSize }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    loadPallets() {
      if (!this.form.wareHouseId) { this.pallets = []; return }
      selectPallet(this.form.wareHouseId).then(res => { this.pallets = res.data || [] }).catch(() => {})
    },
    openEdit(id, readonly) {
      this.readonly = !!readonly
      this.form = emptyForm()
      this.pallets = []
      this.visible = true
      if (!id) return
      getRepacking(id).then(res => {
        const row = res.data || {}
        this.form = Object.assign(emptyForm(), row, { lineList: row.lineList && row.lineList.length ? row.lineList : [emptyLine()] })
        this.loadPallets()
      })
    },
    addLine() { this.form.lineList.push(emptyLine()) },
    copyTo(row) {
      if (row && !row.toProductId) row.toProductId = row.fromProductId
    },
    submit() {
      if (!this.form.wareHouseId) { this.$message.warning('请选择仓库'); return }
      if (!(this.form.lineList || []).length) { this.$message.warning('请添加明细'); return }
      this.saving = true
      const req = this.form.repackingId ? updateRepacking(this.form) : saveRepacking(this.form)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.load()
      }).finally(() => { this.saving = false })
    },
    doPost(row) {
      this.$confirm('确认过账？将扣减来源库存并增加目标库存。', '提示', { type: 'warning' }).then(() => {
        postRepacking(row.repackingId).then(() => { this.$message.success('已过账'); this.load() })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteRepacking([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
